import React from 'react';

const NewPage = () => <div></div>;

export default NewPage;
